import { render, staticRenderFns } from "./PatientPaymentsTab.vue?vue&type=template&id=b6834eae&scoped=true"
import script from "./PatientPaymentsTab.vue?vue&type=script&lang=js"
export * from "./PatientPaymentsTab.vue?vue&type=script&lang=js"
import style0 from "./PatientPaymentsTab.vue?vue&type=style&index=0&id=b6834eae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6834eae",
  null
  
)

export default component.exports